<div class="col-12 mb-4">
    <h5><strong>Container Information</strong></h5>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th class="table-header">From</th>
                <th class="table-header">To</th>
                <th class="table-header">Leg Type</th>
                <th class="table-header">Requested Delivery Date</th>
                <th class="table-header">Completed Date</th>
                <th class="table-header">Truck</th>
                <th class="table-header">Grid #</th>
                <th class="table-header">PIN</th>
                <th class="table-header">Express PIN</th>
                <th class="table-header">Status</th>
            </tr>
        </thead>

        <tbody>
            @if(containerLegsData && containerLegsData.length > 0){
            @for(legData of containerLegsData; track $index){
            <tr>
                <td> {{ legData?.fromName }} </td>
                <td>{{ legData.toName }}</td>
                <td>{{legData?.legTypeName}}</td>
                <td>{{ legData?.requestedDeliveryDate | date: 'dd/MM/yyyy'}}</td>
                <td>{{ getCompletedDate(legData?.completedDateUtc) | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                <td>{{ legData?.truckCode}}</td>
                <td>{{ legData?.gridNumber}}</td>
                <td>{{ legData?.pin}}</td>
                <td>{{ legData?.expressPin}}</td>
                <td>{{ legData?.status?.name}}</td>
            </tr>
            }
            }@else{
            <tr>
                <td colspan="6"></td>
            </tr>
            }
        </tbody>
    </table>
</div>
